import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import React from "react";
import TextArea from "Component/Material-ui/TextArea";
import { instance } from "../../../Actions/AxiosInstance";

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: "",
    };

    this.setFeedback = this.setFeedback.bind(this);
    this.sendFeedback = this.sendFeedback.bind(this);
  }

  setFeedback(value) {
    this.setState({
      feedback: value,
    });
  }

  sendFeedback() {
    if (this.state.feedback != "" && this.state.feedback != null) {
      const data = {
        feedbackrelatedtypeid: 3,
        feedback: this.state.feedback,
        feedbacktypeid: 99,
        via: "Dashboard widget request",
      };
      instance
        .post("superuser/feedback", data)
        .then(() => {
          this.props.enqueueSnackbar("Save successfully", {
            variant: "success",
          });
          this.props.handleClickAway();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      this.props.enqueueSnackbar("Please fill something", { variant: "error" });
    }
  }

  render() {
    return (
      <Grid container>
        <Grid item sm={12} md={12}>
          <p
            style={{ paddingBottom: 16 }}
            className="normal-dark-secondary"
          >
            Mention your ideas and suggestions in the text box
            below
          </p>
          <TextArea
            className="width100"
            maxLength="1000"
            onChange={(e) => this.setFeedback(e.target.value)}
            value={this.state.feedback}
            variant="outlined"
            placeholder=""
            multiline
          />
          <Button
            variant="contained"
            className="btn btn-trans margin-top-16 "
            onClick={this.props.handleClickAway}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="btn btn-primary-sm-blue margin-top-16"
            style={{ marginLeft: 16 }}
            onClick={this.sendFeedback}
          >
            submit
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default Feedback;
